
import { Checkbox } from "@mui/material";
import { getGridContextMenuList } from "../../../_helpers/getGridContextMenuList";
import { LOCAL_STORAGE_GRID_KEYS } from "../../../_constants";
import { LabelColumnV2 } from "../../../components/DataGridV2/DataColumnsV2";

export const getDrawingLocationNameColumns = ({
    t,
    keyPrefix,
    i18n,
    apiRef,
    forProjectValueOptions,
    forBuildingValueOptions,
    setSelectedRecord,
    setSelectedRecordIndex,
    drawingLocationsNames,
    setIsDialogOpen
}) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.DRAWING_LOCATION_NAMES_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.DRAWING_LOCATION_NAMES_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
    })
    return [
        {
            download: true,
            print: true,
            field: "name",
            headerName: t("general.name"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.name}
                        cellSubMenuOptions={{ options: getOptions({ field: "name", isQuickFilterDisplay: Boolean(rowData.name) }), extraData: { fieldName: "name" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "forProject",
            headerName: t("layout.navbar.project"),
            flex: 1,
            minWidth: 90,
            type: "singleSelect",
            valueOptions: forProjectValueOptions,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={<Checkbox
                            sx={{ padding: 0 }}
                            checked={Boolean(rowData.forProject)}
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedRecord(rowData);
                                setSelectedRecordIndex(
                                    drawingLocationsNames.findIndex(item => item.id === rowData.id)
                                );
                                setIsDialogOpen(true);
                            }}
                        />}
                        cellSubMenuOptions={{ options: getOptions({ field: "forProject", isQuickFilterDisplay: rowData.forProject !== undefined && rowData.forProject !== null }), extraData: { fieldName: "forProject", type: "singleSelect" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "forBuilding",
            headerName: t("general.object"),
            type: "singleSelect",
            valueOptions: forBuildingValueOptions,
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={<Checkbox
                            sx={{ padding: 0 }}
                            checked={Boolean(rowData.forBuilding)}
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedRecord(rowData);
                                setSelectedRecordIndex(
                                    drawingLocationsNames.findIndex(item => item.id === rowData.id)
                                );
                                setIsDialogOpen(true);
                            }}
                        />}
                        cellSubMenuOptions={{ options: getOptions({ field: "forBuilding", isQuickFilterDisplay: rowData.forBuilding !== undefined && rowData.forBuilding !== null }), extraData: { fieldName: "forBuilding", type: "singleSelect", } }}
                        request={rowData}
                    />
                );
            },
        },
    ];

}